import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import CheckButton from '../../../../utils/components/CheckButton/CheckButton'
import { useDispatch, useSelector } from 'react-redux';
import { clearPendingOrders, getPendingOrders } from '../../../actions/transferActions';
import { seeWineries } from '../../../actions/wineryActions';
import "../../../../css/Tables.css"
import { Table } from '../../Table/Table';
import TitleSVG from '../../../../utils/components/TitleSVG/TitleSVG';
import { TransferIcon } from '../../../../assets/icons/index';
import style from './Transfer.module.css'
import Button from '../../../../utils/components/Button/Button';
const PendingOrders = ({ location }) => {
    const dispatch = useDispatch()
    const { pendingOrders } = useSelector(state => state.tranfers)
    const { wineriesList } = useSelector((state) => state.wineriesAdmin);
    const [orderType, setOrderType] = useState("purchase")
    const [orderState, setOrderState] = useState(0)

    const orderStateOptions = {
        catering: [
            { name: "Pendiente", option: 0 },
            { name: "Aprobado", option: 2 },
            { name: "Transferido", option: 3 },
            { name: "Entregado", option: 4 },
            { name: "Rechazado", option: 1 },
        ],
        purchase: [
            { name: "Pendiente", option: 0 },
            { name: "Pagado", option: 2 },
            { name: "Despachado", option: 3 },
            { name: "Entregado", option: 4 },
            { name: "Rechazado", option: 1 },
        ],
        consignment: [
            { name: "Pendiente", option: 0 },
            { name: "Aprobado", option: 2 },
            { name: "Despachado", option: 3 },
            { name: "Entregado", option: 4 },
            { name: "Rechazado", option: 1 },
        ],
    }

    useEffect(() => {
        //if (winery) {
        dispatch(getPendingOrders(orderState, orderType))
        //}
        return () => [
            dispatch(clearPendingOrders())
        ]
    }, [orderState, orderType])
    useEffect(() => {
        //  dispatch(seeWineries());
        if (location.state && location.state.type) {
            setOrderType(location.state.type)
        }
    }, [])


    return (
        <div className={`container-page`}>
            <TitleSVG Icon={TransferIcon}
                titleHighlight={'Órdenes'}
                title={' pendientes'} />
            <div className={`content-admin flex-row-start margin-top-20`}>

                <div className={`admin-subtitle margin-right-20`}>Seleccione el tipo de transferencia</div>
                <div>
                    <CheckButton textName={"Abastecimiento"} option={"catering"} setValue={setOrderType} value={orderType} />
                    <CheckButton textName={"Compra"} option={"purchase"} setValue={setOrderType} value={orderType} />
                    <CheckButton textName={"Consignación"} option={"consignment"} setValue={setOrderType} value={orderType} />
                </div>
            </div>


            <div className={`content-admin flex-row-start margin-top-20`}>
                <span className={`admin-subtitle margin-right-20`}>Seleccione el estado de la orden</span>
                <nav className={`flex-row-wrap `}>
                    {orderStateOptions[orderType].map((orderStateOption, index) => (
                        <Button
                            active={orderStateOption.option==orderState}
                            classNameContent={`margin-right-10 width-130`}
                            key={index}
                            text={orderStateOption.name}
                            onClick={() => { 
                                setOrderState(orderStateOption.option);
                                
                             }}
                        />
                    ))}
                </nav>

            </div>
            <div className={`margin-top-20 ${style.pending_order_table}`}>
                <Table>
                    <thead>
                        <tr>
                            <th>CODIGO</th>
                            <th>FECHA</th>
                            <th>REMITENTE</th>
                            <th>ENCARGADO</th>
                            <th>UBICACION</th>
                            <th>ESTADO</th>
                            <th>GESTIONAR</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            pendingOrders.map(pendingOrder => (
                                <tr key={pendingOrder._id}>
                                    <td>{pendingOrder.code}</td>
                                    <td>{new Date(pendingOrder.creationDate).toLocaleDateString()}</td>
                                    <td>
                                        {
                                            pendingOrder?.transmitterRepresentativeId && pendingOrder?.transmitterRepresentativeId?.name
                                        }
                                        {
                                            pendingOrder?.transmitterFranchiseId && pendingOrder?.transmitterFranchiseId?.socialReason
                                        }
                                        {
                                            pendingOrder?.transmitterUserId && `${pendingOrder?.transmitterUserId?.name} ${pendingOrder?.transmitterUserId?.lastname}`
                                        }
                                        {
                                            pendingOrder?.transmitterWarehouseId && pendingOrder?.transmitterWarehouseId?.name
                                        }
                                        {
                                            pendingOrder?.transmitterSubwineryId && pendingOrder?.transmitterSubwineryId?.name
                                        }
                                        {
                                            pendingOrder?.transmitterRepresentativeId && pendingOrder?.transmitterRepresentativeId?.userID.name
                                        }


                                    </td>
                                    <td>{pendingOrder?.receivingWineryId?.name}</td>
                                    <td>
                                        {pendingOrder?.receivingWineryId?.ubication.state}-
                                        {pendingOrder?.receivingWineryId?.ubication.city}
                                    </td>
                                    <td>
                                        {pendingOrder.status ===0 && 'Pendiente'}
                                        {pendingOrder.status ===1 && 'Rechazado'}
                                        {pendingOrder.status ===2 && 'Pagado'}
                                        {pendingOrder.status ===3 && 'Despachado'}
                                        {pendingOrder.status ===4 && 'Entregado'}
                                    </td>
                                    <td>
                                        {
                                            (pendingOrder.status ===0 || pendingOrder.status ===2 || pendingOrder.status ===3) && <Link to={`OrderDetaill/${pendingOrder._id}`}>Gestionar</Link>
                                        }
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </Table>
            </div>
        </div>
    )
}

export default PendingOrders
